export const TextTheme = {
  variants: {
    tooltip: {
      color: "text-inverse",
    },
  },
};
